import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Local storage
import sessionStorage from "redux-persist/lib/storage/session"; // Session storage
import cashierCartReducer from "./ReduxCashierCartReducer";
import guestCartReducer from "./ReduxGuestCartReducer";
import cheffCartReducer from "./ReduxCheffCartReducer";
import userReducer from "./ReduxUser";
import accessRightsReducer from "./ReduxAccessRight";
import accessModulesReducer from "./ReduxAccessModules";
import paymentsReducer from "./ReduxPaymentSlice";
import vouchersReducer from "./ReduxVoucherSlice";
import cardReducer from "./ReduxCardSlice";
import slipReducer from "./ReduxSlipSlice";
import chequeReducer from "./ReduxChequeSlice";
import guestDecodedReducer from "./ReduxGuestDecodedReducer";

// Persist configuration for Cashier Cart (Session Storage)
const cashierCartPersistConfig = {
  key: "cashierCart",
  storage: sessionStorage, // Use session storage
};

// Persist configuration for Guest Cart (Local Storage)
const guestCartPersistConfig = {
  key: "guestCart",
  storage, // Use local storage
};

// Persist configuration for Chef Cart (Session Storage)
const cheffCartPersistConfig = {
  key: "cheffCart",
  storage: sessionStorage, // Use session storage
};

// Persist configuration for User (Local Storage)
const userPersistConfig = {
  key: "user",
  storage, // Use local storage
};

// Persist configuration for Access Rights (Local Storage)
const accessRightsPersistConfig = {
  key: "accessRights",
  storage,
};

const accessModulesPersistConfig = {
  key: "accessModules",
  storage,
};

// Persist configuration for Payments (Session Storage)
const paymentsPersistConfig = {
  key: "payments",
  storage: sessionStorage, // Use session storage for payments
};

// Voucher persist config (Session Storage)
const voucherPersistConfig = {
  key: "vouchers",
  storage: sessionStorage,
};

const cardPersistConfig = {
  key: "cards",
  storage: sessionStorage, // Use session storage
};

const slipPersistConfig = {
  key: "slips",
  storage: sessionStorage, // Use session storage
};

const chequePersistConfig = {
  key: "cheques",
  storage: sessionStorage, // Use session storage
};

// Persist configuration for GuestDecoded (Session Storage)
const guestDecodedPersistConfig = {
  key: "guestDecoded",
  storage: sessionStorage,
};

// Persist GuestDecoded reducer
const persistedGuestDecodedReducer = persistReducer(
  guestDecodedPersistConfig,
  guestDecodedReducer
);

const persistedChequeReducer = persistReducer(
  chequePersistConfig,
  chequeReducer
);

const persistedSlipReducer = persistReducer(slipPersistConfig, slipReducer);

const persistedCardReducer = persistReducer(cardPersistConfig, cardReducer);

const persistedVouchersReducer = persistReducer(
  voucherPersistConfig,
  vouchersReducer
);

// Apply persistReducer to each reducer
const persistedCashierCartReducer = persistReducer(
  cashierCartPersistConfig,
  cashierCartReducer
);
const persistedGuestCartReducer = persistReducer(
  guestCartPersistConfig,
  guestCartReducer
);

const persistedCheffCartReducer = persistReducer(
  cheffCartPersistConfig,
  cheffCartReducer
); // Persist Chef cart

const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
const persistedAccessRightsReducer = persistReducer(
  accessRightsPersistConfig,
  accessRightsReducer
);



const persistedAccessModulesReducer = persistReducer(
  accessModulesPersistConfig,
  accessModulesReducer,
);
const persistedPaymentsReducer = persistReducer(
  paymentsPersistConfig,
  paymentsReducer
);

// Configure the Redux store with persisted reducers
export const store = configureStore({
  reducer: {
    cashierCart: persistedCashierCartReducer,
    guestCart: persistedGuestCartReducer,
    cheffCart: persistedCheffCartReducer,
    user: persistedUserReducer,
    accessRights: persistedAccessRightsReducer,
    accessModules: persistedAccessModulesReducer,
    payments: persistedPaymentsReducer,
    vouchers: persistedVouchersReducer,
    cards: persistedCardReducer,
    slips: persistedSlipReducer,
    cheques: persistedChequeReducer,
    guestDecoded: persistedGuestDecodedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

// Create and export the persistor for the store
export const persistor = persistStore(store);

export default store;
